import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private localizeRouterService: LocalizeRouterService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkMaintenance(state.url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkMaintenance(state.url);
  }

  private checkMaintenance(targetUrl: string): boolean | UrlTree {
    // Si le mode maintenance est activé, rediriger vers la page de maintenance (localisée)
    if (environment.maintenanceMode) {
      // Utiliser le routeur localisé pour générer l'URL correcte selon la langue courante
      const localized = this.localizeRouterService?.translateRoute('/maintenance') as string | undefined;
      const url = localized && typeof localized === 'string' ? localized : 'fr/maintenance';
      return this.router.parseUrl(url);
    }
    return true;
  }
}
